/**
 * Determines whether a given pathname belongs to the "company job" section of the website.
 * The "company job" section contains routes related to company jobs.
 *
 * @param {string | null} pathname - The full pathname to check.
 * @returns {boolean} - `true` if the pathname matches a valid "company job" route; otherwise, `false`.
 */
export const isCompanyJobRoute = (pathname: string | null): boolean => {
  // Return false if pathname is null or empty
  if (!pathname) {
    return false;
  }

  // Define static routes
  const staticRoutes = ['/my-jobs', '/my-job'];

  // Check if pathname contains any of the staticRoutes as a substring
  const isInStaticRoutes = staticRoutes.some((route) => pathname.includes(route));

  return isInStaticRoutes;
};
